import "./PoultryProduction.module.css";
import Header from "@/reusable_sections/Header";
import PresentacionDelCurso from "./sections/PresentacionDelCurso";
import DetallesDelCurso from "./sections/DetallesDelCurso";
import CursosRelacionados from "./sections/CursosRelacionados";
import Footer from "@/reusable_sections/Footer";
export default function PoultryProductionPage() {
  return <div>
      <Header />
      <PresentacionDelCurso />
      <DetallesDelCurso />
      <CursosRelacionados />
      <Footer />
    </div>;
}